export const FooterMoreLinks = [
    {
        title: 'Narkha',
        path: '/',
    },
];